import { Grid, Toolbar, Typography, styled } from "@mui/material";
import React, { FunctionComponent } from "react";
import ControlSectionDivider from "./ControlSectionDivider";

const DrawerItem = styled(Grid)(({ theme }) => ({
    width: "100%",
    paddingLeft: "24px",
    paddingRight: "24px",
}));

const DrawerHeader = styled(Typography)(({ theme }) => ({
    color: theme.palette.info.main,
}));

const DrawerSection = styled(Grid)(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
}));

const InfoTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    "& span": {
        color: theme.palette.info.main,
    },
}));

interface OwnProps {
    sectionTitle: string;
    sectionContent: React.ReactNode;
    titleClassName?: string;
    contentClassName?: string;
    hideSection?: boolean;
    showDivider?: boolean;
}

type Props = OwnProps;

const InfoSection: FunctionComponent<React.PropsWithChildren<Props>> = (
    props,
) => {
    return (
        <>
            {props.sectionContent && !props.hideSection && (
                <>
                    <Toolbar>
                        <DrawerHeader
                            className={props.titleClassName}
                            variant={"h5"}
                        >
                            {props.sectionTitle}
                        </DrawerHeader>
                    </Toolbar>
                    <DrawerSection
                        container
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="center"
                        className={props.contentClassName}
                    >
                        <DrawerItem item xs>
                            <InfoTypography variant={"body2"}>
                                {props.sectionContent}
                            </InfoTypography>
                        </DrawerItem>
                    </DrawerSection>
                    {props.showDivider && <ControlSectionDivider />}
                </>
            )}
        </>
    );
};

export default InfoSection;
